import { useTranslation } from "react-i18next";
import { Tooltip } from "src/components/Default/LekUI/Tooltip";
import SimulationIcon from "src/images/Icons/newIcons/simulation.svg";
import { ExamStatus } from "src/types/enums";

import { useTimer } from "../../Exam/ExamComponents/Timer";

export const SimulationExamType = ({ row }) => {
	const { t } = useTranslation();
	const { finishedAt, pausedAt, state } = row;
	const time = useTimer({ finishedAt, pausedAt, state });

	const renderTime = () => {
		if (row.status === ExamStatus.FINISHED) {
			return null;
		}

		return (
			<div>
				<span>{time}</span>
			</div>
		);
	};

	return (
		<Tooltip title={t("tooltips.simulationWithTimer")}>
			<div className="menu-icon-button flex-center-row px-6 border-radius-6 gap-8">
				<SimulationIcon className="icon-small" />
				{renderTime()}
			</div>
		</Tooltip>
	);
};
